import { Box, Divider, Stack } from '@mui/material';
import scssVariables from '@styles/variables.module.scss';
import cx from 'classnames';
import { NavLink } from 'react-router';

import { LogoFlower, LogoFull } from '../Logo';
import { MainSearch } from '../MainSearch';
import { BookmarksMenu } from './components/BookmarksMenu';
import { CreateMenu } from './components/CreateMenu';
import { HelpButton } from './components/HelpButton';
import { LegacyMainSearch } from './components/LegacyMainSearch';
import { LegacySignUpButton } from './components/LegacySignUpButton';
import { LegacySiteStatus } from './components/LegacySiteStatus';
import { LegacyTimeTrackerButton } from './components/LegacyTimeTrackerButton';
import { PersonalPlanButton } from './components/PersonalPlanButton';
import { SidebarToggle } from './components/SidebarToggle';
import styles from './TopNavigation.module.scss';
import { IconButton } from '@/components/ui/IconButton';
import { homeMenuPathRoute } from '@/constants/menuItems';
import { uiIcons } from '@/constants/uiIcons';
import { useHasNewSearchUI } from '@/hooks/featureFlags';
import { useIsMobile } from '@/hooks/useIsMobile';
import { useMobileNavigationStore } from '@/stores/mobileNavigation';

export const TopNavigation = () => {
  const hasNewSearchUiEnabled = useHasNewSearchUI();

  const isMobile = useIsMobile();
  const { isClosing, setMobileOpen, mobileOpen } = useMobileNavigationStore();

  const handleDrawerToggle = () => {
    if (!isClosing) {
      setMobileOpen(!mobileOpen);
    }
  };

  return (
    <Box className={styles.TopNavigation}>
      <Stack direction="row" gap={{ xs: 1, sm: 3, lg: 5 }} alignItems="center">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent={'space-between'}
          className={cx(styles.TopNavigationLogo)}
        >
          <NavLink
            to={homeMenuPathRoute || '/'}
            data-automation-id="MainNavigationHomeLink"
          >
            {isMobile ? <LogoFlower /> : <LogoFull />}
          </NavLink>
        </Stack>
        <Stack direction="row" gap={{ xs: 1.4, sm: 2 }} alignItems="center">
          {!isMobile && <SidebarToggle />}
          {hasNewSearchUiEnabled ? <MainSearch /> : <LegacyMainSearch />}
          <BookmarksMenu />
          <CreateMenu />
        </Stack>
      </Stack>

      <Stack
        direction="row"
        alignItems="center"
        gap={{ xs: 0.6, sm: 1.2 }}
        divider={
          <Divider
            className={styles.TopNavigationItemDivider}
            orientation="vertical"
            variant="middle"
          />
        }
      >
        <Stack direction="row" gap={{ xs: 0.6, sm: 1.2 }} alignItems="center">
          <LegacySignUpButton />
          <LegacySiteStatus />
          <LegacyTimeTrackerButton />
          <PersonalPlanButton />
        </Stack>
        <Stack direction="row" gap={{ xs: 0.6, sm: 1.2 }} alignItems="center">
          <HelpButton />
          {isMobile && (
            <Stack direction="row" alignItems="center">
              <IconButton
                color="secondary"
                tooltip="Toggle navigation drawer menu"
                aria-expanded={mobileOpen}
                aria-controls="mobile-navigation-drawer"
                onClick={handleDrawerToggle}
                iconName={uiIcons.navigation.menu}
                size="medium"
                iconProps={{ color: scssVariables.ColorBlack100 }}
              />
            </Stack>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};
